import { render, staticRenderFns } from "./TenderDocumentDetail.vue?vue&type=template&id=7a352de3&scoped=true"
import script from "./TenderDocumentDetail.vue?vue&type=script&lang=js"
export * from "./TenderDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./TenderDocumentDetail.vue?vue&type=style&index=0&id=7a352de3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a352de3",
  null
  
)

export default component.exports